export const requestPrivateOrdersAndTradesQuery = () => `
  query privateData($tradingGateway: String!, $symbol: String!, $fromDate: DateTime!, $toDate: DateTime!) {
    privateData(fromDate: $fromDate, toDate: $toDate, symbol: $symbol, tradingGateway: $tradingGateway) {
      orders {
        trading_gateway
        comp_id
        id
        exchange_order_id
        exec_id
        exec_date
        symbol
        exchange_cl_ord_id
        time_in_force
        type
        price
        quantity
        value
        minimum_quantity
        filled_quantity
        remaining_quantity
        visible_quantity
        display_range
        num_trades
        side
        status
        trader_id
        capacity
        liquidity_provision
        self_match_prevention_id
        self_trade_prevention_level
        self_trade_prevention_action
        self_trade_prevention_trader_group
        peg_type
        peg_difference
        created_at
        last_updated
        last_updated_by
        last_price
        average_price
        last_quantity
        market_feed_id
        vwap
        expires_at
        action_reject_reason
        cancel_reason
        routing_strategy
        clearing_firm
        clearing_account
        clearing_account_type
        record_keeping {
          client_id
          client_type
          investment_decision_id
          investment_decision_type
          executing_trader_id
          executing_trader_type
        }
      }
      trades{
        trading_gateway
        comp_id
        order_id
        symbol
        side
        price
        quantity
        value
        visible_quantity
        trade_id
        market_feed_id
        exec_id
        counterparty
        timestamp
        cancelled
        cancelled_at
        replaced_at
        orders {
          id
          status
          trader_id
          last_updated
          record_keeping {
            client_id
            client_type
          }
        }
      }
      inetTradeReports {
        trading_gateway
        comp_id
        id
        trade_report_id
        trade_report_ref_id
        status
        is_initiated
        is_internal
        trader_id
        symbol
        side
        price
        quantity
        value
        settlement_date
        trade_publish_indicator
        trade_registration_timestamp
        capacity
        trade_type
        trade_id
        match_id
        deal_id
        counterparty
        counterparty_capacity
        last_updated
        last_updated_by
        reject_reason
        executing_firm
        execution_method
        reason
        record_keeping {
          client_id
          client_type
        }
        timestamp
        trade_clearing_instruction
      }
      geniuminetTradeReports {
        trading_gateway
        comp_id
        id
        trade_report_id
        trade_report_ref_id
        status
        is_initiated
        is_internal
        trader_id
        symbol
        side
        price
        quantity
        value
        settlement_date
        trade_publish_indicator
        trade_registration_timestamp
        capacity
        trade_type
        trade_id
        match_id
        deal_id
        counterparty
        counterparty_capacity
        last_updated
        last_updated_by
        reject_reason
        executing_firm
        execution_method
        reason
        record_keeping {
          client_id
          client_type
        }
        timestamp
        trade_clearing_instruction
      }
    }
  }
`;
